import { useState } from "react";
import { useHistory } from "react-router-dom";
import "./login.css";
import spinner from "../../assets/spinner4.svg";
import { ArrowLeftCircleIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { ACCESS_TOKEN } from "../../utils/const/string-const";
import { verifyLogin } from "../../api/api-usuario-web";
import { ReactComponent as SignUp } from "../../assets/icons/sign-up.svg";

export default function Login() {
  const [usuario, setUsuario] = useState("");
  const [contrasenia, setContrasenia] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const history = useHistory();

  const submit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const response = await verifyLogin(usuario, contrasenia);
      // console.log('response');
      // console.log(response);
      setLoading(false);

      if (response.error === false) {
        localStorage.setItem(ACCESS_TOKEN, response.body.token);
        history.push(`/dashboard`);
      } else {
        alert('Usuario o contraseña incorrecto');
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };


  return (
    <div className="login-container">
      <form onSubmit={submit} className="login-form">
        <div className="login-box">
          <h2 className="title">Login</h2>

          {/* Language Dropdown */}
          <br />
          <div className="input-fields">
            <div className="field">
              <label htmlFor="usuario_login" className="field-label">Username:</label>
              <input
                id="usuario_login"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                className="login-input"
                type="text"
                placeholder={"username"}
              />
            </div>

            <div className="field">
              <label htmlFor="password" className="field-label">{"password"}:</label>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <input
                  id="password"
                  value={contrasenia}
                  onChange={(e) => setContrasenia(e.target.value)}
                  className="login-input"
                  type={passwordVisible ? "text" : "password"}
                  placeholder={"password"}
                />
                <div
                  className="password-toggle"
                  onClick={() => setPasswordVisible(!passwordVisible)}
                >
                  {passwordVisible ? (
                    <EyeSlashIcon className="password-icon" width={25} />
                  ) : (
                    <EyeIcon className="password-icon" width={25} />
                  )}
                </div>
              </div>
            </div>

            <div className="field bg-[#000D39] flex justify-center text-white p-2 rounded-md"
              onClick={() => {
                if (!loading) {
                  document.getElementById("loginButton")?.click();
                }
              }}
            >
              {loading === false &&
                <button type="onSubmit" className="login_button"
                  onClick={(e) => e.stopPropagation()}
                >
                  {"Login"}
                </button>
              }
              {loading === true &&
                <button className="login_button flex justify-center">
                  <img className="spinner" alt="spinner" src={spinner} />
                </button>}
            </div>
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <ArrowLeftCircleIcon
              width={24}
              color="#0F3457"
              className="back-button"
              onClick={() => history.push(`/landing`)}
            />
            <div
              className="flex flex-col items-center cursor-pointer"
              onClick={() => history.push(`/sign-up`)}
            >
              <SignUp className="w-8 h-8" title="Registrarse" />
              <label className="mt-2">Registrarse</label>
            </div>

          </div>

          <div className="version">1.0.0</div>
        </div>
      </form>
    </div>
  );
}
